/**
 * Web Scraper - Free Web Scraping
 *
 * Its only web-accessible resources are the toolbar icons, and they are scoped to
 * `https://*.webscraper.io/*` — not `<all_urls>`. So the extension is detectable, but
 * only by Web Scraper's own site; from any other origin the icons are unreachable and a
 * negative result proves nothing.
 *
 * This is the correct, contained way to expose a resource — the same shape as
 * Malwarebytes — and a useful contrast with the extensions that hand icons to every
 * origin.
 *
 * Manifest verified against version 1.111.13.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jnhgnonknehpejjnehehllkliplmbmhn';

export const webScraper: ExtensionDefinition = {
  id: ID,
  name: 'Web Scraper - Free Web Scraping',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 800_000,
  requiredOrigin: 'https://www.webscraper.io',
  notes:
    'Icons are the only WAR and are scoped to *.webscraper.io, so only that site can ' +
    'detect it — a properly contained exposure.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon128.png via <img> — exposed only to webscraper.io origins, so ' +
        'this fires there and nowhere else.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon128.png'),
    },
    {
      id: 'war-icon-48',
      kind: 'web-accessible-resource',
      description: 'Load images/icon48.png via <img> — a second origin-scoped icon.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon48.png'),
    },
  ],
};
